function parseLength(value: string | null | undefined, fallback = 0): number {
  if (!value) return fallback;
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function strokeWidthToMm(
  strokeWidthUserUnits: number,
  mmPerUserUnitX: number,
  mmPerUserUnitY: number
): number {
  const scale = (Math.abs(mmPerUserUnitX) + Math.abs(mmPerUserUnitY)) / 2;
  return strokeWidthUserUnits * scale;
}

export function readStrokeWidthUserUnits(computed: CSSStyleDeclaration, element: Element): number {
  const fromStyle = parseLength(computed.strokeWidth, 0);
  if (fromStyle > 0) return fromStyle;
  const attr = element.getAttribute('stroke-width');
  return parseLength(attr, 1);
}
